import {useMemo} from 'react'
import {useWatch} from 'react-hook-form'

import {useFieldConfigurationContext} from '../../configuration/useConfigurationContext'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'

import {getTruckSize} from './trucks.utils'

export const useTrucks = () => {
  const {control, setValue, trigger, formState: {defaultValues}} = useOrderProcessFormContext()
  const truckConfiguration = useFieldConfigurationContext('trucks')
  const [truckType, isMultipleTruck] = useWatch({
    name: ['truckType', 'isMultipleTruck'],
    control
  })
  const defaultTruckType = defaultValues?.truckType
  const defaultIsMultipleTruck = defaultValues?.isMultipleTruck
  const setTruckType = (newTruckType: string) => {
    // send analytics?
    // should we check if newTruckType is in truckConfiguration?
    setValue('truckType', newTruckType)
    trigger()
  }

  const truckSize = useMemo(
    () => getTruckSize(truckConfiguration, truckType),
    [truckType, truckConfiguration]
  )

  const truckTypeSettings = useMemo(() => {
    if (!truckConfiguration.isEnabled) {
      return []
    }
    return truckConfiguration.truckTypes
  }, [truckConfiguration])

  return {
    truckTypeSettings,
    truckType,
    defaultTruckType,
    defaultIsMultipleTruck,
    setTruckType,
    truckSize,
    isMultipleTruck,
    configuration: truckConfiguration
  }
}
